// extracted by mini-css-extract-plugin
export default {"container":"author-page_container__vqgUR","header":"author-page_header__2yIa5","filters":"author-page_filters__3Ycbi"};